import { PathDictionary } from '../types/interfaces';

export const pathDictionary: PathDictionary = {
  absences: 'Виды отсутствий',
  assets: 'Объекты',
  assetParameters: 'Характеристики объектов',
  assetTypes: 'Типы объектов',
  calendars: 'Календари',
  calendarAssignments: 'Календарь назначений',
  employeeCard: 'Карточка сотрудников',
  employeesTable: 'Сотрудники',
  feedback: 'Обратная связь',
  functionalStructure: 'Функциональная структура',
  geographicalZones: 'Географические зоны',
  history: 'История изменений графика назначений',
  newTask: 'Карточка наряда',
  operationTypes: 'Работы',
  Privacy_policy: 'Политика конфиденциальности',
  processingWorkOrders: 'Процессы обработки нарядов',
  roles: 'Реестр микро-ролей',
  complexRole: 'Конфигуратор ролей',
  schedules: 'Расписания',
  taskClosingCodes: 'Шифры закрытия нарядов',
  skillsAndCertifications: 'Навыки и допуски',
  taskStatuses: 'Статусы нарядов',
  tasksType: 'Типы нарядов',
  measureUnit: 'Единицы измерения',
  avgTransportSpeed: 'Реестр средних скоростей',
  departmentAssignmentHistory: 'История распределения нарядов по участкам',
  planningAlgorithms: 'Алгоритмы распределения нарядов по сотрудникам',
  personAssignmentHistory:
    'История автоматического распределения нарядов по сотрудникам'
  // расширение кастомных имен для хлебных крошек
};
